import axios from 'axios';

import { VersionHistory } from 'components/types';

import { VERSION_HISTORY } from '../endpoints';

export const getVersionHistory = ({ signal }) =>
  axios.get<VersionHistory>(VERSION_HISTORY, {
    signal
  });
